import script from "./messageRedEnvelope.vue?vue&type=script&setup=true&lang=js"
export * from "./messageRedEnvelope.vue?vue&type=script&setup=true&lang=js"

import "./messageRedEnvelope.vue?vue&type=style&index=0&id=657fe7b9&scoped=true&lang=css"
import "./messageRedEnvelope.vue?vue&type=style&index=1&id=657fe7b9&lang=css"

import exportComponent from "D:\\Jawsro\\company\\虎鲸\\v3\\hujing_pro_h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-657fe7b9"]])

export default __exports__